import { mapMaterialSubCategoryType, MaterialSubCategoryType } from "./MaterialSubCategoryType";

export interface TemplateType {
    id: number;
    template_id: number | null;
    category_id: number | null;
    sub_category_id: number | null;
    length: number | null;
    width: number | null;
    hight: number | null;
    status: 1 | 0;
    unit_cost: number | null;
    material_sub_category: MaterialSubCategoryType | null;
}

// to single object maping
export const mapTemplateType = (data: any): TemplateType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const templateType: TemplateType = {
        id: data.id,
        template_id: data.template_id || null,
        category_id: data.category_id || null,
        sub_category_id: data.sub_category_id || null,
        length: data.length || null,
        width: data.width || null,
        hight: data.hight || null,
        status: data.status,
        unit_cost: data.unit_cost || null,
        material_sub_category: data.material_sub_category !== null ? mapMaterialSubCategoryType(data.material_sub_category) : null,
    }

    return templateType;
}

// maping list objects
export const mapTemplateTypes = (data: any[]): TemplateType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapTemplateType);
}